import React, { useEffect, useState } from "react";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { StyledContainer } from "../../globalStyle/GlobalStyle";
import { PageHeader, ParametersWrapper } from "./Parameters.styled";
import { FormContainer } from "../../components/Form/FormComponents.styled";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setParameters, setVariables } from "./ParameterSlice";
import { fetchParameters } from "./utils";
import AddIcon from "../../assets/icons/addIcon.svg";
import EditIcon from "../../assets/icons/editIcon.svg";
import { toast } from "react-toastify";

/* eslint-disable no-unused-vars */
const Parameters = () => {
	const dispatch = useDispatch();
	const pageData = useSelector((state) => state.parameters.data);
	const [defaultData, setDefaultPageData] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		getParameters();
	}, []);

	// eslint-disable-next-line no-unused-vars
	const getParameters = async () => {
		const data = await fetchParameters();
		if (data && !data.error) {
			setLoading(false);
			console.log(data);
			// Dispatching data to redux store
			setDefaultPageData(data.parameters);
			dispatch(setParameters(data.parameters));
			dispatch(setVariables(data.variables));
		} else {
			setLoading(false);
			dispatch(setParameters([]));
			toast.error("Error fetching data!");
		}
	};

	return (
		<AdminDashboardLayout data={pageData} defaultData={defaultData}>
			<StyledContainer>
				<ParametersWrapper>
					<PageHeader>
						<Button variant='outlined' component={Link} to='/parameters/input-variables'>
							<img src={AddIcon} alt='' />
							Input Variables
						</Button>

						<div className='button_group'>
							<Button variant='outlined' component={Link} to='/parameters/add-new'>
								<img src={AddIcon} alt='' />
								Add Parameter
							</Button>
						</div>
					</PageHeader>

					<FormContainer>
						<div className='parametersList w-full'>
							<div className='grid grid-cols-5 gap-3'>
								<div className='heading'>Parameters</div>
								<div className='heading'>Value</div>
								<div className='heading'>Period</div>
								<div className='heading'>Terms</div>
							</div>

							{pageData &&
								pageData.map((item) => {
									return (
										<div className='grid grid-cols-5 gap-3' key={item?.id}>
											<div className='listItem'>{item?.parameter || "---"} </div>
											<div className='listItem'>{item?.value || "---"}</div>
											<div className='listItem'>{item?.period || "---"}</div>
											<div className='listItem'>{item?.term || "---"}</div>
											<div className='listItem col-last'>
												<Button
													variant='outlined'
													component={Link}
													to={`/parameters/edit/${item?.id}`}
													className='editButton'>
													<img src={EditIcon} alt='' />
													<span>Edit</span>
												</Button>
											</div>
										</div>
									);
								})}
						</div>
					</FormContainer>
				</ParametersWrapper>
			</StyledContainer>

			{loading && (
				<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AdminDashboardLayout>
	);
};

export default Parameters;
